import { createFileRoute } from '@tanstack/react-router'
import { HelpCenter } from '@/features/public-site/help-center'
import { getHelpPage } from '@/features/public-site/help-content'

export const Route = createFileRoute('/help/$slug')({ component: HelpArticleRoute })
function HelpArticleRoute() { const { slug } = Route.useParams(); return <HelpCenter page={getHelpPage(slug)} /> }
